import React from 'react';
import { Row, Col } from 'antd';
import { GetBest, Invest, Trade, Earn } from '../../assets/icons';
import './MarketCard.scss';

const MarketCard = () => {
  return (
    <div className='marketcard-wrapper'>
      <div className='container-fluid'>
        <Row gutter={[16, 16]}>
          <Col className='marketcard' sm={12} md={6}>
            <div className='marketcard__block'>
              <GetBest color='#8A4743' />
              <h4>Browse</h4>
              <p>Every property on Realbricks is carefully vetted to meet strict investment standards—so you can confidently choose from high-quality opportunities.
              </p>
            </div>
          </Col>
          <Col className='marketcard' sm={12} md={6}>
            <div className='marketcard__block'>
              <Invest color='#8A4743' />
              <h4>Invest</h4>
              <p>Start investing with as little as $100. You can own up to 9.8% of any property listed on our platform, all based on your budget and goals.</p>
            </div>
          </Col>
          <Col className='marketcard' sm={12} md={6}>
            <div className='marketcard__block'>
              <Trade color='#8A4743' />
              <h4>Earn</h4>
              <p>Sit back and earn passive income. You’ll receive quarterly dividends from the rental income of any property you own—no work required.</p>
            </div>
          </Col>
          <Col className='marketcard' sm={12} md={6}>
            <div className='marketcard__block'>
              <Earn color='#8A4743' />
              <h4>Grow</h4>
              <div>
                <p>Expand your real estate portfolio over time by adding new properties and reinvesting your dividends while benefiting from long term property appreciation.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className='marketcard__gradient'></div>
    </div>
  );
};

export default MarketCard;
